import { isTrue } from '@/libs/boolean';
import ApplicationController from './application_controller';

// Botón que al hacer click muestra u oculta los elementos según la selección
/* global $, Cifra */
export default class extends ApplicationController {
  connect() {
    this.$element = $(this.element);
    const { target } = this.element.dataset;
    if (!target) {
      throw new Error('Falta de configurar el target para activar o desactivar');
    }

    // Siempre quitamos el class hide, ya lo gestionamos nosotros con jquery

    $(target).filter('.hide').hide().removeClass('hide');
    this.$element.on('click', (event) => {
      event.preventDefault();
      $(target).fadeToggle(Cifra.Conf.ANIMATION_SPEED_FAST);
    });

    if (isTrue(this.element.dataset.ocultarInicio)) {
      $(target).hide();
    }
  }
}
